import React from "react";
import "./GalleryPage.css";

function GalleryPage({ title }) {
  // Placeholder images - replace with actual photo URLs
  const photos = [
    { id: 1, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+1" },
    { id: 2, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+2" },
    { id: 3, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+3" },
    { id: 4, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+4" },
    { id: 5, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+5" },
    { id: 6, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+6" },
    { id: 7, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+7" },
    { id: 8, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+8" },
    { id: 9, url: "https://via.placeholder.com/400x400/333/fff?text=Photo+9" },
  ];

  return (
    <div className="gallery-page">
      <div className="gallery-background"></div>
      <div className="gallery-container">
        <h1 className="gallery-title">{title}</h1>
        <div className="gallery-grid">
          {photos.map((photo) => (
            <div key={photo.id} className="gallery-item">
              <img src={photo.url} alt={`Gallery ${photo.id}`} />
              <div className="gallery-overlay"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GalleryPage;
